<template>
  <div class="manual-google-cv-contents">
    <el-row>
      <el-col>
        <h2>成果データのダウンロード方法（AFAD）</h2>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <CommonDescription :systemType="'afad'" />
        <h4>
          【１】<a href="https://affi-ads.com/" target="_blank" rel="noopener noreferrer">管理画面</a
          >にログインし、「レポート」→「獲得ログ」をクリックします。
        </h4>
        <img :src="`${rt}/img/manual/google-cv/no07/no23/01.png`" alt="" />
        <h4>【２】「検索条件」を開きます。</h4>
        <img :src="`${rt}/img/manual/google-cv/no07/no23/02.png`" alt="" />
        <h4>【３】期間を選択して、「検索する」をクリックします。</h4>
        <img :src="`${rt}/img/manual/google-cv/no07/no23/03.png`" alt="" />
        <h4>
          【４】CSVをダウンロードします。「CSVダウンロード」をクリックします。
        </h4>
        <img :src="`${rt}/img/manual/google-cv/no07/no23/04.png`" alt="" />

        <p>これで成果CSVのダウンロードは完了です。</p>
        「
        <router-link :to="`/manual/${tool.codeKebab}/07/14`"
          >ASPの成果データをアドタスカルにインポートする</router-link
        >」に進んでください。
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CommonDescription from "@/components/Manual/Tools02/Parts/CommonDescription.vue";

export default {
  name: "ManualGoogleCvContents",
  components: {
    CommonDescription,
  },
  props: {},
  computed: {
    ...mapGetters(["rt", "tool", "tools"]),
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.mini-img {
  width: 50%;
}
</style>
